import { useMemo } from 'react'; 
import { useMutation } from '@apollo/client';
import COMPLETION_CODE_CREATE from '../mutations/COMPLETION_CODE_CREATE';

const useCompletionCodeCreate = () => {
    const [ createNewCode ] = useMutation( COMPLETION_CODE_CREATE );

    const createCode = async ( iltID, code ) => {
        try {
            const response = await createNewCode( { 
                variables: { 
                    input: {
                        code,
                        iltID
                    }
                } 
            } );

            const success = response?.data?.createCompletionCode;

            if ( success ) {
                return {
                    success: true,
                    response: response.data.createCompletionCode
                };
            } else {
                return {
                    success: false,
                    response
                };
            }
        } catch ( error ) { 
            console.error( 'Error creating code', error );  
            return {
                success: false,
                response: error
            };
        } 
    };

    return useMemo( () => {
        return {
            createCode         
        };
    }, [] );
};

export default useCompletionCodeCreate;
